/* eslint-disable */
import * as DateHelper from '../helpers/date'
import _ from 'lodash'


const createAchievement = (user, achievementName, dispatch) => {
  const key = `achievement${achievementName}`
  if (!user.additionalInfo[key]) {

    dispatch('CREATE_ACHIEVEMENT', { actionName: achievementName })
    dispatch('ADDITIONAL_USER_INFO', { [key]: true })
  }
}


export default ({ user, dispatch, activeDays }) => {
  if (activeDays === 2) {
    createAchievement(user, 'SecondDay', dispatch)
  }

  if (activeDays === 5) {
    createAchievement(user, 'FourDayStreak', dispatch)
  }

  if (user.registeredAt > DateHelper.daysAgo(8) && user.registeredAt < DateHelper.daysAgo(6)) {
    createAchievement(user, 'AfterOneWeek', dispatch)
  }

  if (user.registeredAt > DateHelper.daysAgo(32) && user.registeredAt < DateHelper.daysAgo(30)) {
    createAchievement(user, 'AfterOneMonth', dispatch)
  }
}
